<!-- Detail Hero Section -->
<section class="detail-hero-section">
  <div class="hero-background">
    <div class="gradient-overlay"></div>
    <div class="particles"></div>
  </div>
  <div class="container">
    <div class="hero-content">
      <nav class="hero-crumbs" aria-label="Breadcrumb">
        <a routerLink="/">Home</a>
        <span aria-hidden="true">/</span>
        <a routerLink="/games">Games</a>
      </nav>
      <h1 class="hero-title">{{ gameDetails?.name || 'Loading game…' }}</h1>
      <div class="hero-meta" *ngIf="gameDetails">
        <span class="hero-meta__pill" *ngIf="gameDetails?.genre">{{ gameDetails.genre }}</span>
        <span class="hero-meta__stat" *ngIf="clickCount !== null">
          <i class="fa fa-play" aria-hidden="true"></i> {{ clickCount }} plays
        </span>
      </div>
      <p class="hero-description" *ngIf="errorMessage">{{ errorMessage }}</p>
    </div>
  </div>
</section>

<div class="game-detail-page">
  <div class="container">
    <div class="detail-layout">
      <div class="game-primary">
        <div class="poster-shell">
          <img
            [src]="'data:image/png;base64,' + (gameDetails?.image || '')"
            [alt]="gameDetails?.name"
            class="poster-image"
          />
          <div class="poster-gradient"></div>
          <div class="poster-caption">
            <span class="genre-pill">{{ gameDetails?.genre || 'Arcade' }}</span>
            <h2 class="title">{{ gameDetails?.name }}</h2>
            <p class="subtitle">Jump in and compete with players across the region.</p>
          </div>
        </div>

        <div class="action-row">
          <a class="btn play-btn" [href]="gameDetails?.url" target="_blank" (click)="onGameClick()">Play Now</a>
          <button class="btn share-btn" type="button" (click)="shareGame()">Share</button>
          <a class="btn back-games-btn" routerLink="/games">Back to All Games</a>
          <span class="clicks-badge" *ngIf="clickCount !== null">{{ clickCount }} Plays</span>
        </div>
        <p class="share-message" *ngIf="shareMessage">{{ shareMessage }}</p>
      </div>

      <aside class="game-sidebar">
        <div class="sidebar-card">
          <h3>Do more games</h3>
          <p>
            Play anytime, discover new adventures, and keep your streak alive with more titles.
          </p>

          <div class="section-header">
            <h4>Popular</h4>
          </div>
          <div class="popular-list">
            <div class="popular-item" *ngFor="let game of popularGames" (click)="openGame(game)">
              <img [src]="'data:image/png;base64,' + game.image" [alt]="game.name" />
              <div class="name">{{ game.name }}</div>
            </div>
          </div>
          <a routerLink="/games" class="explore-below-grid">Explore All</a>
        </div>
      </aside>
    </div>
  </div>
</div>
